import React from 'react'
import cx from 'classnames'
import { track } from 'analytics'
import { useDevice } from 'local_modules/device'
import links from 'links'
import { Button, ButtonBase } from 'components/inputs'
import { Text, BackgroundImage } from 'components/dataDisplay'

import messages from './messages'
import s from './HolidaySeasonBanner.scss'

import bgDesktop from './images/bg-desktop.jpg'
import bgMobile from './images/bg-mobile.jpg'


type HolidaySeasonBannerProps = {
  discount?: number
  className?: string
  position: number
}

const HolidaySeasonBanner: React.FC<HolidaySeasonBannerProps> = ({ className, discount, position }) => {
  const { isMobile } = useDevice()

  return (
    <ButtonBase
      to={discount ? links.shop.holiday : links.gifts}
      onClick={() => {
        track('Banner click', {
          placement: 'Header',
          content: 'Holiday season',
          action: 'link',
          link: discount ? links.shop.holiday : links.gifts,
          position,
        })
      }}
    >
      <BackgroundImage src={isMobile ? bgMobile : bgDesktop}>
        <div
          className={cx(className, s.banner)}
          data-testid="holidaySeasonBanner"
        >
          <div className={cx('flex justify-center items-center h-full', isMobile ? 'gap-40' : 'gap-16')}>
            <Text
              className="text-white"
              message={
                discount ? {
                  ...messages.title,
                  values: { discount },
                } : messages.defaultTitle
              }
              style="h8"
            />
            <Button className="px-8" size={38} noPadding title={messages.button} />
          </div>
        </div>
      </BackgroundImage>
    </ButtonBase>
  )
}

export default HolidaySeasonBanner
